import React, { useEffect, useState, useCallback } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import axios from "axios";
import Card from "components/card";
import { readToken } from "utils/session";

Chart.register(ArcElement, Tooltip, Legend);

const UnifiedDonutChart = () => {
  const [chartsData, setChartsData] = useState([]);
  const userKey = readToken();

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  const getColor = (index) => {
    const colors = [
      "#42AACC",
      "#EE5D50",
      "#4299e1",
      "#A3AED0",
      "#D69E2E",
      "#809D3C",
      "#A35C7A",
    ];
    return colors[index % colors.length];
  };

  const processChartData = useCallback((data) => {
    const preparedCharts = data.map((chartData) => {
      const { DonutChartDetails, plotData } = chartData;
      const labels = Object.keys(DonutChartDetails).filter(
        (key) => key !== "DonutChartName" && key !== "timestamps"
      );

      const datasets = labels.map((key, index) => ({
        label: DonutChartDetails[key],
        data: plotData[key],
        backgroundColor: getColor(index),
        borderWidth: 1,
      }));

      return {
        title: DonutChartDetails.DonutChartName,
        chartData: {
          labels: plotData.timestamps,
          datasets,
        },
      };
    });

    setChartsData(preparedCharts);
  }, []);

  useEffect(() => {
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${apiBaseUrl}/api/fleetsummary`,
      headers: {
        Authorization: `Bearer ${userKey}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        const data =
          response.data.summaryitems[0].DonutChartInfo.DonutChartData;
        processChartData(data);
      })
      .catch((error) => console.error(error));
  }, [apiBaseUrl, userKey, processChartData]);

  if (chartsData.length === 0) return <div>Loading...</div>;

  return (
    <div
      className="grid gap-5"
      style={{
        gridTemplateColumns: `repeat(${Math.min(
          chartsData.length,
          4
        )}, minmax(0, 1fr))`,
      }}
    >
      {chartsData.map((chart, index) => (
        <Card key={index} extra="rounded-[20px] p-3 h-[450px] relative">
          <div className="flex flex-row justify-between px-3 pt-2">
            <h4 className="text-lg font-bold text-navy-700 dark:text-white">
              {chart.title}
            </h4>
          </div>

          <div
            className="mb-auto flex h-[380px] w-full items-center justify-center"
            style={{
              maxHeight: "300px",
              maxWidth: "100%",
              marginTop: "20px",
            }}
          >
            <Doughnut
              data={chart.chartData}
              options={{
                responsive: true,
                plugins: {
                  legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                      color: "#000",
                      generateLabels: (chart) => {
                        const { datasets } = chart.data;
                        return datasets.map((dataset) => ({
                          text: dataset.label,
                          fillStyle: dataset.backgroundColor,
                        }));
                      },
                    },
                  },
                },
              }}
            />
          </div>
        </Card>
      ))}
    </div>
  );
};

export default UnifiedDonutChart;
